module.exports = __webpack_public_path__ + "static/media/jimmy_tang.a7931783.png";